import * as React from 'react';

import { BaseTooltip } from './base-tooltip';

export interface InfoTooltipTextProps {
  title: React.ReactNode;
  description?: React.ReactNode;
}

export const InfoTooltipText: React.FC<InfoTooltipTextProps> = ({
  title,
  description,
}) => {
  return (
    <div className="flex flex-col">
      <span className="text-sm font-bold leading-5 text-gray-800">{title}</span>
      {description && (
        <div
          className="text-xs leading-[1.125rem] text-gray-600"
          style={{ letterSpacing: '0.03em' }}
        >
          {description}
        </div>
      )}
    </div>
  );
};

export interface InfoTooltipProps {
  title: React.ReactNode;
  description?: React.ReactNode;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
  className?: string;
  /** Controlled open state; see `BaseTooltip`. */
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  children: React.ReactNode;
}

export const InfoTooltip: React.FC<InfoTooltipProps> = ({
  title,
  description,
  side,
  align,
  className,
  open,
  onOpenChange,
  children,
}) => {
  return (
    <BaseTooltip
      side={side}
      align={align}
      className={className}
      open={open}
      onOpenChange={onOpenChange}
    >
      <BaseTooltip.Trigger>{children}</BaseTooltip.Trigger>
      <BaseTooltip.Content>
        <InfoTooltipText title={title} description={description} />
      </BaseTooltip.Content>
    </BaseTooltip>
  );
};
